import React from 'react';
import { Form, Input } from 'antd';

interface IdInputProps {
  name?: string;
}

export function IdInput(props: IdInputProps) {
  return (
    <Form.Item name={props.name || 'id'} hidden>
      <Input type="text" disabled />
    </Form.Item>
  );
}
